export async function exportFile(url, params, type, name) {
    const res = await this.axios.post(url, params, { responseType: 'arraybuffer' });
    const tempBlob = new Blob([res.data], { type: 'application/json' })
    // 通过 FileReader 读取这个 blob
    const reader = new FileReader()
    reader.onload = e => {
        const res1 = e.target.result
        // 此处对fileReader读出的结果进行JSON解析
        // 可能会出现错误，需要进行捕获
        try {
            const json = JSON.parse(res1)
            //正常json数据格式
            this.$message({
                showClose: true,
                message: json.msg,
                type: 'error'
            });
        } catch (error) {
            // // 该异常为无法将字符串转为json
            // // 说明返回的数据是一个流文件
            // // 不需要处理该异常，只需要捕获即刻
            if (type == 'pdf') {
                const aLink = document.createElement('a');
                const blob = new Blob([res.data], { type: 'application/pdf' })
                aLink.href = URL.createObjectURL(blob);
                aLink.setAttribute('download', name + '.pdf'); // 设置下载文件名称
                aLink.click();
            } else if (type == 'excel') {
                const aLink = document.createElement('a');
                let blob = new Blob([res.data], {
                    type: 'application/vnd.ms-excel'
                });
                aLink.href = URL.createObjectURL(blob);
                aLink.setAttribute('download', name + '.xlsx'); // 设置下载文件名称
                aLink.click();
            } else if (type == 'word') {
                const aLink = document.createElement('a');
                let blob = new Blob([res.data], {
                    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                });
                aLink.href = URL.createObjectURL(blob);
                aLink.setAttribute('download', name + '.docx'); // 设置下载文件名称
                aLink.click();
            } else if (type == 'zip') {
                const aLink = document.createElement('a');
                let blob = new Blob([res.data], { type: "application/zip" });
                aLink.href = URL.createObjectURL(blob);
                aLink.setAttribute('download', name + '.zip'); // 设置下载文件名称
                aLink.click();
            }
        }
    }
    reader.readAsText(tempBlob)
}


// WEBPACK FOOTER //
// ./src/components/exportfile.js